import FormControlLabel from '@material-ui/core/FormControlLabel';
import React, { FC, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { Checkbox, CircularProgress, makeStyles } from '@material-ui/core';
import { CheckboxContainer } from 'styles/Form/CheckboxContainer';
import { Input } from 'styles/Form/Input';
import { SubTitle } from 'styles/Form/SubTitle';
import { Title } from 'styles/Title';
import { Review } from 'types/review';
import { ContactsStageButtonContainer } from 'styles/Form/ContactsStageButtonContainer';
import { FormButton } from 'styles/Form/FormButton';
import { ButtonBody } from 'styles/Form/ButtonBody';
import { useTranslation } from 'react-i18next';
import { Meta } from 'types/meta';
import { ButtonText } from 'styles/Form/ButtonText';

interface ContactsStageProps {
  meta: Meta;
  countryCode: string;
  review: Review;
  setReview: React.Dispatch<React.SetStateAction<Review>>;
  nextStage: () => void;
}
export const ContactsStage: FC<ContactsStageProps> = ({
  meta,
  countryCode,
  review,
  setReview,
  nextStage
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [anonymous, setAnonymous] = useState(false);

  const [nameValid, setNameValid] = useState(false);
  const [phoneValid, setPhoneValid] = useState(false);

  return (
    <>
      <Title>{t('thankYou')}</Title>
      <SubTitle>{t('leaveYourContacts')}:</SubTitle>
      {review.contacts_required === 'flexible' && (
        <CheckboxContainer>
          <FormControlLabel
            control={
              <Checkbox
                checked={anonymous}
                onChange={() => setAnonymous(!anonymous)}
              />
            }
            label={t('doNotContactMe')}
          />
        </CheckboxContainer>
      )}
      {!anonymous && (
        <>
          <Input
            invalid={!nameValid}
            value={review.name}
            color={meta.color}
            style={{ height: '50px' }}
            placeholder={t('name') + '*'}
            onChange={({ target: { value: name } }) => {
              setNameValid(name.length > 0);
              setReview({ ...review, name });
            }}
          />

          <PhoneInput
            value={review.phone}
            country={countryCode.toLowerCase()}
            countryCodeEditable={false}
            containerStyle={{
              border: !phoneValid ? '1px solid #d90429' : 'none',
              borderRadius: '10px'
            }}
            inputClass={classes.phoneInput}
            buttonClass={classes.btnFlag}
            buttonStyle={{
              borderWidth: 0,
              border: 'none !important',
              height: '50px',
              marginLeft: '10px',
              background: 'none !important'
            }}
            dropdownClass={classes.dropdown}
            onChange={phone => {
              const richPhone = parsePhoneNumberFromString('+' + phone);
              setPhoneValid(richPhone !== undefined && richPhone.isValid());
              setReview({
                ...review,
                phone: phone
              });
            }}
          />
        </>
      )}
      <ContactsStageButtonContainer>
        <FormButton
          style={{ width: '100%' }}
          color={meta.color}
          onClick={() => {
            if (anonymous || (nameValid && phoneValid)) nextStage();
          }}
        >
          <ButtonBody>
            {review.sending ? (
              <CircularProgress />
            ) : (
              <ButtonText>
                {anonymous || (nameValid && phoneValid)
                  ? t('send')
                  : t('fillFieldsCorrectly')}
              </ButtonText>
            )}
          </ButtonBody>
        </FormButton>
      </ContactsStageButtonContainer>
    </>
  );
};

export const useStyles = makeStyles({
  phoneInput: {
    position: 'relative',
    background: '#F7F9FB',
    fontSize: '17px',
    padding: '0px 55px',
    width: '100% !important',
    height: '50px !important',
    fontStyle: 'inherit',
    backgroundColor: '#f7f9fb !important',
    fontFamily: 'Montserrat, sans-serif !important',
    paddingLeft: '20px',
    color: 'black',
    display: 'block',
    borderRadius: '10px !important',
    margin: '15px 15px 20px 0',
    border: '1px solid #ececec !important ',
    '&:focus': {
      outline: 'none'
    },
    '&::placeholder': {
      fontSize: '18px',
      color: '#444444'
    }
  },
  dropdown: {
    background: '#F7F9FB !important'
  },
  btnFlag: {
    background: 'none !important',

    '& .selected-flag.open, .selected-flag': {
      background: 'transparent !important'
    }
  }
});
